module.exports = __webpack_public_path__ + "img/m_aboutUs.53abc8cc.jpg";